import taxTableServiceGen from "./generated/taxTableServiceGen";

class taxTableService extends taxTableServiceGen {
}

export default taxTableService;